import h from 'hyperscript';

import styles from './section.module.css';
import './section.css';

const COMPONENT_NAME = 'd-section';

class Section extends HTMLElement {
  constructor() {
    super();
    const shadowRoot = this.attachShadow({ mode: 'open' });
    shadowRoot.append(
      h('.header', [h('slot.summary', { name: 'summary' }), h('slot.summary-aside', { name: 'summary-aside' })]),
      h('slot.content'),
    );
    shadowRoot.adoptedStyleSheets = [styles];
  }

  connectedCallback() {
    this.classList.add(COMPONENT_NAME);
    slotSummary(this);
  }
}

export function slotSummary(element: HTMLElement) {
  const summary = element.querySelector(':scope > summary');
  if (summary) {
    summary.slot = 'summary';
  }
}

customElements.define(COMPONENT_NAME, Section);
declare global {
  interface HTMLElementTagNameMap {
    [COMPONENT_NAME]: Section;
  }
}
